import { useId } from 'react';

import PropTypes from 'prop-types';

import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import {
  CalloutIconCard as Card,
  CalloutIconCardContent as CardContent,
  CalloutIconWrapper as Wrapper
} from './CalloutIcon.style';

export default function CalloutIcon({
  description,
  icon,
  iconBackgroundColor,
  title,
  ...delegated
}) {
  const uniqueId = useId();
  const drawerId = delegated.id ?? uniqueId;
  const labelledby = title ? `${drawerId}-callout-title` : `${drawerId}-callout-description`;
  const describedby = `${drawerId}-callout-description`;

  return (
    <Card
      aria-describedby={describedby}
      aria-labelledby={labelledby}
      role="complementary"
      {...delegated}
    >
      <CardContent>
        <Wrapper iconBackgroundColor={iconBackgroundColor}>{icon}</Wrapper>
        <Stack gap={0.5}>
          {title && (
            <Heading id={labelledby} size="md">
              {title}
            </Heading>
          )}
          {description && (
            <Text id={describedby} size="sm">
              {description}
            </Text>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

CalloutIcon.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  iconBackgroundColor: PropTypes.string
};
